<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="2.25" transform="rotate(-90 13 13)" stroke="currentColor" stroke-width="1.5"/>
<circle cx="8" cy="3" r="2.25" transform="rotate(-90 8 3)" stroke="currentColor" stroke-width="1.5"/>
<circle cx="3" cy="13" r="2.25" transform="rotate(-90 3 13)" stroke="currentColor" stroke-width="1.5"/>
<path d="M6.64844 4.95312L4.1872 10.426" stroke="currentColor" stroke-width="1.5"/>
</svg>
